export default "__VITE_ASSET__CVF5r2In__"